import { render, staticRenderFns } from "./OsPanel.vue?vue&type=template&id=550ef9cc&scoped=true&"
import script from "./OsPanel.vue?vue&type=script&lang=js&"
export * from "./OsPanel.vue?vue&type=script&lang=js&"
import style0 from "./OsPanel.vue?vue&type=style&index=0&id=550ef9cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550ef9cc",
  null
  
)

export default component.exports